/**
 * Яндекс.Метрика и прочая аналитика.
 * Метрика включается только при VUE_APP_METRIKA_ENABLED=true (в .env.production на боевом деплое).
 */
export const ANALYTICS_DISABLED = process.env.VUE_APP_METRIKA_ENABLED !== 'true';
